import gql from "graphql-tag";

export default gql`
  mutation LazadaImportOrderUpdateBookingFile($_id: ID!, $status: Int) {
    lazadaImportOrderUpdate(_id: $_id, status: $status) {
      _id
    }
  }
`;
